export const sessionTimeoutMaxAge = 20 * 60; // in seconds
